(() => {
  const SELECTOR = '[data-pm-desktop-sales]';

  function parseJson(root, selector, fallback) {
    const node = root.querySelector(selector);
    if (!node) return fallback;

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error(`Pulse desktop: JSON inválido en ${selector}`, error);
      return fallback;
    }
  }

  function setupProductTabs(root) {
    const products = parseJson(root, '[data-pm-desktop-products]', {});
    const tabs = Array.from(root.querySelectorAll('[data-pm-product-tab]'));
    const image = root.querySelector('[data-pm-product-image]');
    const kicker = root.querySelector('[data-pm-product-kicker]');
    const title = root.querySelector('[data-pm-product-title]');
    const price = root.querySelector('[data-pm-product-price]');
    const compare = root.querySelector('[data-pm-product-compare]');
    const description = root.querySelector('[data-pm-product-description]');
    const points = root.querySelector('[data-pm-product-points]');
    const link = root.querySelector('[data-pm-product-link]');

    function selectProduct(tab) {
      const product = products[tab.dataset.productKey];
      if (!product) return;

      root.dataset.pmSelectedProduct = tab.dataset.productKey;

      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });

      if (image && product.image) {
        image.src = product.image;
        image.removeAttribute('srcset');
        image.alt = product.alt || product.title || '';
      }
      if (kicker) kicker.textContent = product.kicker || '';
      if (title) title.textContent = product.title || '';
      if (price) price.textContent = product.price || '';
      if (compare) {
        compare.hidden = !product.compare;
        compare.textContent = product.compare || '';
      }
      if (description) description.textContent = product.description || '';
      if (points) {
        points.replaceChildren(
          ...(product.points || []).map((point) => {
            const item = document.createElement('li');
            item.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="m5 12 4 4L19 6"></path></svg>';
            const text = document.createElement('span');
            text.textContent = point;
            item.append(text);
            return item;
          })
        );
      }
      if (link) {
        link.href = product.url || '#';
        const label = document.createTextNode(`${product.label || 'Ver producto'} `);
        link.replaceChildren(label);
        link.insertAdjacentHTML('beforeend', '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M5 12h14"></path><path d="m13 6 6 6-6 6"></path></svg>');
      }
    }

    tabs.forEach((tab, index) => {
      tab.tabIndex = index === 0 ? 0 : -1;
      tab.addEventListener('click', () => selectProduct(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = tabs.indexOf(tab);
        if (event.key === 'ArrowRight') nextIndex = (nextIndex + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (nextIndex - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        tabs[nextIndex].focus();
        selectProduct(tabs[nextIndex]);
      });
    });
  }

  function setupWeekTabs(root) {
    const weeks = parseJson(root, '[data-pm-desktop-weeks]', []);
    const tabs = Array.from(root.querySelectorAll('[data-pm-week-tab]'));
    const image = root.querySelector('[data-pm-week-image]');
    const number = root.querySelector('[data-pm-week-number]');
    const title = root.querySelector('[data-pm-week-title]');
    const text = root.querySelector('[data-pm-week-text]');
    const panel = root.querySelector('[data-pm-week-panel]');

    function selectWeek(index) {
      const week = weeks[index];
      if (!week) return;

      tabs.forEach((tab, tabIndex) => {
        const selected = tabIndex === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      if (panel && tabs[index]) panel.setAttribute('aria-labelledby', tabs[index].id);

      if (image && week.image) {
        image.src = week.image;
        image.alt = week.alt || week.title || '';
      }
      if (number) number.textContent = week.number || `Semana ${index + 1}`;
      if (title) title.textContent = week.title || '';
      if (text) text.innerHTML = week.html || '';
    }

    tabs.forEach((tab, index) => {
      tab.tabIndex = index === 0 ? 0 : -1;
      tab.addEventListener('click', () => selectWeek(index));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        tabs[nextIndex].focus();
        selectWeek(nextIndex);
      });
    });

    root.addEventListener('shopify:block:select', (event) => {
      const selectedTab = tabs.find((tab) => tab.dataset.pmWeekBlockId === event.detail.blockId);
      if (!selectedTab) return;
      selectWeek(tabs.indexOf(selectedTab));
    });
  }

  function initialize(root) {
    if (root.dataset.pmDesktopInitialized === 'true') return;
    root.dataset.pmDesktopInitialized = 'true';
    setupProductTabs(root);
    setupWeekTabs(root);
  }

  function initializeAll(container = document) {
    container.querySelectorAll(SELECTOR).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
